import React from 'react';

import SubtitleRegular from 'components/Typography/SubtitleRegular';

import './index.scss';

export interface ProgressoAprovacaoProps {
  aprovadas: number;
  total: number;
  percentual: number;
}

/** Barra "N de M seções aprovadas · P%" — azul enquanto parcial, verde em 100%. */
export default function ProgressoAprovacao({
  aprovadas, total, percentual,
}: ProgressoAprovacaoProps) {
  const completo = total > 0 && aprovadas === total;

  return (
    <div className="relatorio-aprovacao-progresso-aprovacao">
      <div className="relatorio-aprovacao-progresso-aprovacao__texto">
        <SubtitleRegular>{`${aprovadas} de ${total} seções aprovadas`}</SubtitleRegular>
        <SubtitleRegular>{`${percentual}%`}</SubtitleRegular>
      </div>
      <div
        className="relatorio-aprovacao-progresso-aprovacao__trilha"
        role="progressbar"
        aria-label={`${aprovadas} de ${total} seções aprovadas`}
        aria-valuenow={percentual}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`relatorio-aprovacao-progresso-aprovacao__preenchimento ${completo ? 'relatorio-aprovacao-progresso-aprovacao__preenchimento--completo' : ''}`}
          style={{ width: `${percentual}%` }}
        />
      </div>
    </div>
  );
}
